<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_v">contents</a></h2><a id="page_v">
</a><p class="toc"><a id="page_v"></a><a class="nounder" href="#/xhtml/part01#part01">STUPID CUPID</a></p>
<p class="toc"><span class="nounder" href="#/xhtml/part02#part02" title="Link target outside of Sample">FLIRTING WITH DISASTER</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/part03#part03" title="Link target outside of Sample">PUCKER UP</span><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?eb4206fe